"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeBase64Attachment = void 0;
var _ramda = require("ramda");
var _base64Helpers = require("./base64Helpers");
// String -> Uint8Array
function stringToUnicodeBytes(str) {
  var bytes = new Uint8Array(str.length * 2),
    i = 0,
    charCode;
  for (; i < str.length; i += 1) {
    charCode = str.charCodeAt(i);
    bytes[i * 2] = charCode & 0xFF;
    bytes[i * 2 + 1] = charCode >> 8;
  }
  return bytes;
}

// Uint8Array, Number, Number -> void
// Writes the specified value as an int32 value to the byteArray at the specified offset
function writeInt32(byteArray, offset, value) {
  var i = 0;
  for (; i < 4; i += 1) {
    byteArray[offset + i] = value >> 8 * i & 0xFF;
  }
}

// Uint8Array, String -> Uint8Array
function getBase64AttachmentBytes(fileBytes, fileName) {
  // size needed is 4 (signature) + 20 (header) + 2 * (fileName.length + 1) + fileBytes.length
  var totalFileNameLength = fileName.length + 1,
    encodedSize = 24 + totalFileNameLength * 2 + fileBytes.length,
    bytes = new Uint8Array(encodedSize),
    offset = 16;

  // signature
  var byteArray = [0xC7, 0x49, 0x46, 0x41];
  byteArray.forEach(function (b, i) {
    bytes[i] = b;
  });
  bytes[4] = 0x14; // header length
  bytes[8] = 0x01; // version

  writeInt32(bytes, offset, fileBytes.length);
  offset += 4;
  writeInt32(bytes, offset, totalFileNameLength);
  offset += 4;
  bytes.set(stringToUnicodeBytes(fileName), offset);
  offset += totalFileNameLength * 2;
  bytes.set(fileBytes, offset);
  return bytes;
}

// (Uint8Array, String) -> String
var encodeBase64Attachment = (0, _ramda.compose)(_base64Helpers.byteArrayToBase64, getBase64AttachmentBytes);
exports.encodeBase64Attachment = encodeBase64Attachment;